import {
  REGISTER_USER_FAILED, REGISTER_USER_SUCCESSFULLY,
  USER_LOGIN_SUCCESSFULLY, USER_LOGIN_FAILED, FORGOT_PASSWORD_SUCCESSFULLY,
  FORGOT_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESSFULLY,
  RESET_PASSWORD_FAILED, VERIFY_USER_SUCCESSFULLY, VERIFY_USER_FAILED
} from '../types';
import axiosInstance from '../../Lib/axios';


// Register User
export const userRegister = (params, uuid) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/staff-user/${uuid}/update_user_details/`, params, {})
      .then((response) => {
        dispatch({
          type: REGISTER_USER_SUCCESSFULLY,
          data: response.data,
        });

      })
      .catch((error) => {
        if (error.response) {
          dispatch({
            type: REGISTER_USER_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};


// Login User
export const userLogin = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/auth/login/`, params, {})
      .then((response) => {
        dispatch({
          type: USER_LOGIN_SUCCESSFULLY,
          data: response.data,
        });
        // set login user in localstorage
        localStorage.setItem('authUser', JSON.stringify(response.data));
      })
      .catch((error) => {
        if (error.response) {
          dispatch({
            type: USER_LOGIN_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

// Forgot Password 
export const forGotPWD = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/auth/password/reset-custom/`, params, {})
      .then((response) => {
        dispatch({
          type: FORGOT_PASSWORD_SUCCESSFULLY,
          data: response.data,
        });

      })
      .catch((error) => {
        if (error.response) {
          dispatch({
            type: FORGOT_PASSWORD_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};

export const newPassword = (params) => {
  return (dispatch) => {
    return axiosInstance.post(`/auth/password/reset/confirm/`, params)
      .then((response) => {
        dispatch({
          type: RESET_PASSWORD_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: RESET_PASSWORD_FAILED,
            data: error.response.data,
          });
        }


      });
  };
};


// verify user of detail
export const verifyRegisterUser = (params) => {
  return (dispatch) => {
    return axiosInstance
      .post(`/crm/staff-user/add_user_confirmation/`, params, {})
      .then((response) => {
        dispatch({
          type: VERIFY_USER_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          dispatch({
            type: VERIFY_USER_FAILED,
            data: error.response.data,
          });
        }
      });
  };
};